import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VposFutureBillingSearch } from 'src/app/models/vpos-future-billing-search';
import { VposVaultAppView } from 'src/app/models/vpos-vault-app-view';
import { VposRecurringBillingAppView } from 'src/app/models/vpos-recurring-billing-app-view';
import { AnyKindOfDictionary } from 'lodash';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { catchError, map } from 'rxjs';
@Injectable()
export class FutureBillingService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }

  getFutureBillings(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposFutureBillingSearch>(environment.getFutureBillingsListUrl + '?merchantKeyId=' + merchantKeyId+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers });

  }
  getFutureBillingById(Id, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposRecurringBillingAppView>(environment.getFutureBillingById + '?id=' + Id + '&merchantKeyId=' + merchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }

  getFutureBillingHistoryById(Id, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getRecurringBillingHistoryDetails + '?merchantKeyId=' + merchantKeyId + '&historyId=' + Id+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }
  getVaultsByMerchantId(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposVaultAppView>(environment.getVaultsByMerchantId + '?merchantKeyId=' + merchantKeyId+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers });

  }
  getVaultsByEmail(email, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposVaultAppView>(environment.getVaultsByEmailUrl + '?Email=' + email + '&MerchantKeyId=' + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });

  }
  createFutureBilling(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.createFutureBillingUrl, data, { headers: this.headers });

  }
  updateFutureBilling(data) {

    this.GetHeaderdetails();
    return this.http.put(environment.modifyFutureBillingUrl, data, { headers: this.headers });
  }
  deleteFutureBilling(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.put(environment.deleteFutureBillingUrl + "?MerchantKeyId=" + merchantdata.MerchantKeyId+ "&LoginUserId="+merchantdata.UserId, data, { headers: this.headers });

  }
  AddCard(data, email) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.AddNewCardUrl + "?Email=" + email + '&MerchantKeyId=' + merchantdata.MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , data, { headers: this.headers });
  }

  createNewOrder(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.createRecurringBillingUrl, data, { headers: this.headers });
  }


  EditRecurringBillingOrder(data) {
    this.GetHeaderdetails();
    return this.http.put<any>(environment.editRecurringBillingUrl, data, { headers: this.headers });
  }

  checkDuplicatePlanNames(planname, merchantkeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposRecurringBillingAppView>(environment.checkDuplicatePlanNames + '?plan=' + planname + '&merchantkeyId=' + merchantkeyid+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }
  getVaultDetailsById(vaultId, merchantkeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposVaultAppView>(environment.getVaultsById + '?id=' + vaultId + '&merchantkeyId=' + merchantkeyid+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }

  CheckStatus(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.checkRecurringBillingStatus, data, { headers: this.headers });
  }

  getFutureBillingsListUrl(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFutureBillingsListUrl + '?MerchantKeyId=' + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers });
  }


  getFutureBillingSchedulesFilterUrl(MerchantKeyId, Fromdate1, todate1, futureBillingId, fltrEmail1) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFutureBillingSchedulesFilterUrl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 +
      "&todate=" + todate1 + "&BillingId=" + futureBillingId + "&Email=" + fltrEmail1 + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });



  }
  getRecurringBillingFilterDataUrl(data) {
    this.GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get<any>(environment.getRecurringBillingFilterDataUrl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&Email=" + fltrEmail1
    //   + "&MobileNo=" + fltrmobileno1 + "&BillingType=" + fltrBillingType1 + "&Planname=" + fltrplanname1 + "&Pattern=" + fltrpattern1 + "&Amount=" + fltrAmount1 + "&Symbol=" + fltrSymbol1 + "&LoginUserId=" + merchantdata.UserId
    //   , { headers: this.headers });
    return this.http.post<any>(environment.getRecurringBillingFilterDataUrl,data,{headers:this.headers});
  }

  GetuserRoleBasedPermissions(userId, appName) {
    this.GetHeaderdetails();
    console.log("futureBillingService");
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.getUserRoleBasedPermissions + "?UserId=" + userId + "&AppName=" + appName+"&LoginUserId="+merchantdata.UserId+"&MerchantKeyId="+merchantdata.MerchantKeyId, { headers: this.headers })
  }

  getFutureBillingSchedulesListUrl(MerchantKeyId, futureBillingId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFutureBillingSchedulesListUrl + "?MerchantKeyId=" + MerchantKeyId + "&billingId=" + futureBillingId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });

  }


  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
}
